document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('[id^="countdown-cta-"][data-end]');
  if (!sections.length) return;

  sections.forEach((container) => {
    const startDate = parseDate(container.dataset.start);
    const endDate = parseDate(container.dataset.end);
    if (!endDate) return;

    const units = {
      days: container.querySelector('[data-unit="days"]'),
      hours: container.querySelector('[data-unit="hours"]'),
      minutes: container.querySelector('[data-unit="minutes"]'),
      seconds: container.querySelector('[data-unit="seconds"]')
    };

    const pad = (val) => (val < 10 ? `0${val}` : `${val}`);

    const updateCountdown = () => {
      let now = new Date();
      if (startDate && now < startDate) {
        now = startDate;
      }

      const diff = endDate - now;
      if (diff <= 0) {
        setValues(0, 0, 0, 0);
        return false;
      }

      let seconds = Math.floor(diff / 1000);
      const days = Math.floor(seconds / 86400);
      seconds -= days * 86400;
      const hours = Math.floor(seconds / 3600);
      seconds -= hours * 3600;
      const minutes = Math.floor(seconds / 60);
      seconds -= minutes * 60;

      setValues(days, hours, minutes, seconds);
      return true;
    };

    const setValues = (days, hours, minutes, seconds) => {
      if (units.days) units.days.textContent = pad(days);
      if (units.hours) units.hours.textContent = pad(hours);
      if (units.minutes) units.minutes.textContent = pad(minutes);
      if (units.seconds) units.seconds.textContent = pad(seconds);
    };

    const interval = setInterval(() => {
      if (!updateCountdown()) {
        clearInterval(interval);
      }
    }, 1000);

    updateCountdown();
  });
});

function parseDate(value) {
  if (!value) return null;
  let normalized = value.trim();
  if (/^\d{4}-\d{2}-\d{2}/.test(normalized)) {
    normalized = normalized.replace(' ', 'T');
  }
  let parsed = new Date(normalized);
  if (isNaN(parsed.getTime())) {
    normalized = normalized.replace(/-/g, '/');
    parsed = new Date(normalized);
  }
  return isNaN(parsed.getTime()) ? null : parsed;
}

